<template>
    <div class="app-autocomplete-input">
        <app-input
            type="text"
            v-model="search"
            :message="message"
            :label="label"
            :placeholder="placeholder"
            :error="error"
            :autofocus="autofocus"
            :readonly="readonly"
            :tooltip="tooltip"
            autocomplete="off"
            :disabled="disabled"
            @keydown.delete.native="clear"
            @input="onInput"
            :disable-on-loading="false"
            :loading="searching"
            ref="input"
            @keydown.prevent.down="highlightNext"
            @keydown.prevent.up="highlightPrevious"
            @keydown.enter="selectHighlighted"
        ></app-input>

        <div class="list" v-if="items.length">
            <div
                class="item"
                v-for="(item, index) in items"
                :class="{ 'highlighted': index === highlightedIndex }"
                @click="select(item)"
                :key="item.value"
            >
                {{ item.label }}
            </div>
        </div>
    </div>
</template>

<script>
import AppInput from "./Input";

export default {
    name: "app-autocomplete-input",

    components: { AppInput },

    props: {
        value: [Object],
        label: String,
        placeholder: String,
        error: Boolean,
        message: String,
        autofocus: Boolean,
        readonly: Boolean,
        tooltip: {
            type: [Boolean, String],
            default: false
        },
        disabled: false,
        searchCb: [Function]
    },

    data() {
        return {
            newValue: this.value || { label: "", value: "" },
            search: "",
            searching: false,
            valid: false,
            items: [],
            highlightedIndex: -1,
            dropdownOpen: false
        };
    },
    async mounted() {
        window.addEventListener("keydown", this.handleKeyDown);

        if (this.value) {
            this.search = this.value.label;

            const value = await this.searchCb(this.search);

            if (value.length) {
                this.valid = true;
            }
        }
    },

    beforeDestroy() {
        window.removeEventListener("keydown", this.handleKeyDown);
    },

    watch: {
        value() {
            if (!this.value && this.valid) {
                this.valid = false;
                this.search = "";
            }

            this.newValue = this.value || { label: "", value: "" };
        }
    },

    methods: {
        async onInput() {
            await this.$nextTick();

            this.items = (await this.searchCb(this.search)) || [];
            this.dropdownOpen = true;
        },

        select(item) {

            if (this.valid) {
                this.$emit("reset");
            }

            this.valid = true;
            this.newValue = item;
            this.search = item.label;
            this.items = [];


            this.$emit("input", this.newValue);
            this.dropdownOpen = false;
        },

        clear() {
            this.valid = false;
            this.$emit("reset");

            if (this.newValue.value) {
                this.newValue = { label: "", value: "" };
                this.search = "";
                this.items = [];
            }
        },

        handleKeyDown(event) {
            if (this.dropdownOpen) {
                if (event.key === "ArrowDown") {
                    this.highlightNext();
                } else if (event.key === "ArrowUp") {
                    this.highlightPrevious();
                } else if (event.key === "Enter") {
                    event.preventDefault(); // Prevent form submission
                    this.selectHighlighted();
                }
            }
        },

        highlightNext() {
            console.log('highlight next');
            if (this.items.length === 0) return; // If no items, return

            if (this.highlightedIndex === this.items.length - 1) {
                // If the last item is currently highlighted, select the first item
                this.highlightedIndex = 0;
            } else {
                // Otherwise, highlight the next item
                this.highlightedIndex++;
            }
        },

        highlightPrevious() {
            console.log('highlight previous');
            if (this.items.length === 0) return; // If no items, return

            if (this.highlightedIndex === 0) {
                // If the first item is currently highlighted, select the last item
                this.highlightedIndex = this.items.length - 1;
            } else {
                // Otherwise, highlight the previous item
                this.highlightedIndex--;
            }
        },

        selectHighlighted() {
            if (this.highlightedIndex !== -1) {
                this.select(this.items[this.highlightedIndex]);
            }
        }
    },

    computed: {}
};
</script>

<style lang="scss" scoped>
.app-autocomplete-input {
    position: relative;

    .list {
        position: absolute;
        top: 100%;
        right: 0;
        min-width: 240px;
        width: 100%;
        background-color: white;
        box-shadow: 0 10px 50px 0 rgba(0, 84, 255, 0.2);
        border-radius: 10px;
        max-height: 200px;
        overflow: auto;
        z-index: 500;

        .item {
            padding: 8px 10px;
            cursor: pointer;

            &:hover {
                background-color: rgba(black, 0.1);
            }
        }
    }
}

.highlighted {
    background-color: lightgray;
}
</style>
